import { render, staticRenderFns } from "./NetInternalArea.vue?vue&type=template&id=b062822e&"
import script from "./NetInternalArea.vue?vue&type=script&lang=ts&"
export * from "./NetInternalArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports